import React from 'react';
import { useComponents } from '@tencent/dz-elements';
import { DetailModal } from '../../../components';
import styles from './style/index.less';
import { formateImageWebp } from '../../../utils';
var ActivityModal = function (_a) {
    var activity = _a.activity, show = _a.show, onHide = _a.onHide;
    var _b = useComponents(), View = _b.View, Image = _b.Image;
    return (React.createElement(DetailModal, { title: "\u6D3B\u52A8\u8BE6\u60C5", className: styles['activity-modal'], show: show, onHide: onHide, height: '50%' },
        React.createElement(View, { className: styles['detail-title'] }, activity.title),
        React.createElement(Image, { className: styles['activity-image'], src: formateImageWebp(activity.picUrl), imageWidth: 750, imageHeight: 1600 })));
};
export default ActivityModal;
